import { sculpturePhoenix } from "./sculpture-phoenix";
import type { VisualizerConfig } from "./types";

// The visualizer registry — mirrors themes/index.ts. A visualizer slots in by
// adding to this array and touches nothing else (the registry couples on the
// VisionView data contract, not geometry — Appendix B.4). sculpture-phoenix is
// the default and, for now, only render (plan §4 Option A: real sculpted mesh,
// masked reveal, territory, damage).
const visualizers: VisualizerConfig[] = [sculpturePhoenix];

const visualizerIndex: Record<string, VisualizerConfig> = Object.fromEntries(
  visualizers.map((visualizer) => [visualizer.id, visualizer])
);

export const DEFAULT_VISUALIZER_ID = "sculpture-phoenix";

export function listVisualizers(): VisualizerConfig[] {
  return visualizers.slice();
}

export function getVisualizer(id: string): VisualizerConfig {
  return visualizerIndex[id] ?? visualizerIndex[DEFAULT_VISUALIZER_ID]!;
}

export function isKnownVisualizer(id: string): boolean {
  return Object.prototype.hasOwnProperty.call(visualizerIndex, id);
}

export type { VisualizerConfig, VisualizerProps } from "./types";
